define(['exports', 'react', 'material-ui', '../../assets/close.svg'], function (exports, _react, _materialUi, _close) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _close2 = _interopRequireDefault(_close);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CloseButtonDialog = function (_React$Component) {
    _inherits(CloseButtonDialog, _React$Component);

    function CloseButtonDialog(props) {
      _classCallCheck(this, CloseButtonDialog);

      var _this = _possibleConstructorReturn(this, (CloseButtonDialog.__proto__ || Object.getPrototypeOf(CloseButtonDialog)).call(this, props));

      _this.state = { title: _this.renderTitle(props.title) };
      return _this;
    }

    _createClass(CloseButtonDialog, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.state = { title: this.renderTitle(nextProps.title) };
      }
    }, {
      key: 'handleClose',
      value: function handleClose() {
        this.props.onRequestClose();
      }
    }, {
      key: 'renderTitle',
      value: function renderTitle(title) {
        var _this2 = this;

        return _react2.default.createElement(
          'div',
          { className: 'clearfix pt2 pr2', onClick: this.props.clickHandler && this.props.clickHandler.bind(this, false) },
          _react2.default.createElement(
            'div',
            { className: 'col col-11 h4 light pt1 nunito-font main-heading' },
            title
          ),
          _react2.default.createElement(
            'div',
            { className: 'col col-1 right-align' },
            _react2.default.createElement(
              _materialUi.IconButton,
              { onTouchTap: function onTouchTap() {
                  return _this2.handleClose();
                } },
              _react2.default.createElement(_close2.default, { className: 'svg-icon svg-large svg-black' })
            )
          )
        );
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_materialUi.Dialog, _extends({}, this.props, this.state))
        );
      }
    }]);

    return CloseButtonDialog;
  }(_react2.default.Component);

  exports.default = CloseButtonDialog;


  CloseButtonDialog.propTypes = {};
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/CloseButtonDialog.js
// module id = 280
// module chunks = 0